export default __webpack_public_path__ + "static/media/fauna-docs-2018-p1.289caef0.png";